import React from 'react'
import { isNil } from 'lodash'

import { formatDateUk } from '../../../core/utils'

import { StyledUpdatedText } from '../../../menu-curation-tasks/components/styled'
import { unknownWordTimestampsPropType } from '../../prop-types'
import { StyledUnknownWordsTimestampsContainer } from '../styled'

const UnknownWordsTimestamps = ({ timestamps }) => {
  const { curatedAt, curatedBy, qadAt, qadBy } = timestamps

  return (
    <StyledUnknownWordsTimestampsContainer>
      {!isNil(curatedAt) && !isNil(curatedBy) && (
        <StyledUpdatedText>
          {`Curated: ${formatDateUk(curatedAt)} by ${curatedBy.email}`}
        </StyledUpdatedText>
      )}
      {!isNil(qadAt) && !isNil(qadBy) && (
        <StyledUpdatedText>
          {`QAd: ${formatDateUk(qadAt)} by ${qadBy.email}`}
        </StyledUpdatedText>
      )}
    </StyledUnknownWordsTimestampsContainer>
  )
}

UnknownWordsTimestamps.propTypes = {
  timestamps: unknownWordTimestampsPropType,
}

UnknownWordsTimestamps.defaultProps = {
  timestamps: {},
}

export default UnknownWordsTimestamps
